import Vue from 'vue'
import Vuex from 'vuex'
import { stringify } from 'querystring';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    childInfo: JSON.parse(localStorage.getItem('childInfo')) || [],
    activeChildInfo: JSON.parse(localStorage.getItem('activeChildInfo')) || {id:''}
  },
  mutations: {
    setUserInfo(state, obj){
      state.userInfo = obj;
      localStorage.setItem('token',obj.token);
      localStorage.setItem('userInfo',JSON.stringify(obj) );
    },
    setChildInfo(state, obj){
      state.childInfo = obj;
      localStorage.setItem('childInfo',JSON.stringify(obj))
    },
    setActiveChildInfo(state, obj){
      state.activeChildInfo = obj;
      localStorage.setItem('activeChildInfo',JSON.stringify(obj))
    }
  },
  actions: {
    setUserInfo(content, obj){
      content.commit('setUserInfo', obj);
    },
    setChildInfo(content, obj){
      content.commit('setChildInfo', obj);
    },
    setActiveChildInfo(content, obj){
      content.commit('setActiveChildInfo', obj);
    },
  },
  modules: {
  }
})
